<div class="card min-w-[320px] max-w-[480px]">
  <h2 class="mt-4 font-bold text-2xl">Bienvenida a Luxoro</h2>
  <p class="my-3 text-sm">Antes de empezar vamos a establecer tu contraseña</p>
  <form [formGroup]="resetPassword" class="mt-8" (ngSubmit)="onSubmit()">
    <div class="field">
      <p-password
        styleClass="w-full"
        formControlName="password"
        [feedback]="false"
        [toggleMask]="true"
        placeholder="Nueva contraseña"
      ></p-password>
    </div>
    <div class="mt-2" *ngIf="isValidField('password')">
        <p-message
          severity="error"
          text="La contraseña no es válida"
        ></p-message>
      </div>
    <div class="field mt-3">
      <p-password
        styleClass="w-full"
        formControlName="repeatPassword"
        [feedback]="false"
        [toggleMask]="true"
        placeholder="Repite tu contraseña"
      ></p-password>
    </div>
    <div class="mt-2" *ngIf="isValidField('repeatPassword')">
        <p-message
          severity="error"
          text="Las contraseñas no coinciden"
        ></p-message>
      </div>
    <div class="mt-12">
      <p-button
        type="submit"
        [disabled]="!resetPassword.valid"
        [loading]="loadingOp"
        label="Guardar contraseña"
        styleClass="w-full" 
      ></p-button>
    </div>
  </form>
</div>
<p-toast />